import { lazy } from 'react';

const CertificatesInVerificationConfig = {
	settings: {
		layout: {
			config: { footer: { display: false } }
		}
	},
	routes: [
		{
			path: '/manufacturer/certificates-in-verification',
			component: lazy(() => import('./CertificatesInVerificationContainer'))
		}
	]
};

export default CertificatesInVerificationConfig;
